import { render, staticRenderFns } from "./gk_exclude.vue?vue&type=template&id=85d7fc4c"
import script from "./gk_exclude.vue?vue&type=script&lang=js"
export * from "./gk_exclude.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports